import React from 'react';
import classNames from 'classnames';
import useFontClassName from '../../hooks/use-font-class-name';
import useIsFeedDesignEnabled from '../../hooks/use-is-feed-design-enabled';
import styles from './empty-states.scss';

type EmptyStatesProps = {
  className?: string;
  title?: React.ReactNode;
  content?: React.ReactNode;
  controls?: React.ReactNode;
};

const EmptyStates: React.FC<EmptyStatesProps> = ({ title, content, className, controls }) => {
  const { getPostClassName } = useIsFeedDesignEnabled();
  const { titleFontClassName, contentFontClassName } = useFontClassName();

  const containerClassName = classNames(
    styles.container,
    contentFontClassName,
    className,
    ['blog-card-background-color', 'blog-text-color'],
    getPostClassName('post-container', 'background-color'),
  );

  const titleContainerClassName = classNames(
    titleFontClassName,
    getPostClassName('title-font', 'title-color'),
  );

  const contentContainerClassName = classNames(
    styles.content,
    getPostClassName('description-font', 'description-color'),
  );

  return (
    <div data-hook="empty-state-container" className={containerClassName}>
      <div className={titleContainerClassName} data-hook="empty-states__title">
        <div className={styles.header}>{title}</div>
      </div>
      <div className={contentContainerClassName}>
        <div className={styles.description}>{content}</div>
      </div>
      {controls && <div className={styles.controls}>{controls}</div>}
    </div>
  );
};

export default EmptyStates;
